import {connect} from '@modifi/redux'
import {aPush} from '@modifi/router'

import CompanyIntroduction, {CompanyIntroductionProps} from './CompanyIntroduction'
import {
  aReset,
  aSavePage,
  selectInitialFormData,
  selectSaveErrorMessage,
  selectSavePending,
} from './store'
import {selectPublicRegisteredCompanies} from '../../../../data/public-registered-companies'
import {ROUTE_INTRO} from '../../../../routes/constants'
import {PRE_UNDERWRITING_COMPANY_FINANCIALS} from '../constants'

const mapStateToProps = (
  state: Record<string, any>
): Pick<
  CompanyIntroductionProps,
  'saveErrorMessage' | 'savePending' | 'formData' | 'possibleCompanyMatches'
> => ({
  saveErrorMessage: selectSaveErrorMessage(state),
  savePending: selectSavePending(state),
  formData: selectInitialFormData(state),
  possibleCompanyMatches: selectPublicRegisteredCompanies(state) || [],
})

const mapDispatchToProps = {
  onSubmit: aSavePage,
  onDiscard: (): any => aReset(),
  redirectToCompanyFinancials: (): any =>
    aPush(ROUTE_INTRO, {page: PRE_UNDERWRITING_COMPANY_FINANCIALS}),
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyIntroduction)
